module.exports = __webpack_public_path__ + "static/media/image_20.6a500d34.png";